import { css } from '@emotion/css';

export const bubbleLabel = (params) => css`
  display: flex;
  width: calc(${params?.bubbleSize} + 40px);
  border-color: ${params?.borderColor};
  border-style: solid;
  border-width: ${params?.borderSize};
  padding: 6px 12px;
  border-radius: ${params?.borderRadius};
  justify-content: space-between;
  font-weight: bold;
  align-items: center;
  color: ${params?.textColor};
  text-transform: capitalize;
  background: transparent;
  font-family: inherit;
  font-size: 0.9em;
  box-sizing: border-box;
  background: ${params?.backgroundColor};
  ${(params?.clickable || params?.enableTopLevelBubble) && (
    'cursor: pointer;'
  )}

  ${params?.isActive && (`
    border-color: ${params?.hoverBorderColor};
    border-style: solid;
    border-width: ${params?.borderSize};
    color: ${params?.hoverTextColor};
    background: ${params?.hoverBackgroundColor};
  `)}
`;
